import React from 'react';

export default function Clear(): JSX.Element {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginLeft: '6px',
      }}
    >
      <path d="M1 1L6.53134 7" stroke="#FF6347" strokeMiterlimit="10" />
      <path d="M7 1L1 7" stroke="#FF6347" strokeMiterlimit="10" />
    </svg>
  );
}
